// For Get insurance_carriers
export const GET_ANSWER_FROM_QUERY = "GET_ANSWER_FROM_QUERY"
export const GET_ANSWER_FROM_QUERY_SUCCESS = "GET_ANSWER_FROM_QUERY_SUCCESS"
export const GET_ANSWER_FROM_QUERY_ERROR = "GET_ANSWER_FROM_QUERY_ERROR"
